<template>
  <div v-if="options.length > 0" class="product__options">
    <div class="size-modal-row" v-if="showSizeModal">
      <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.91339 9.59584C10.902 9.59584 12.5237 8.37466 12.5237 6.87857C12.5237 5.38231 10.9068 4.16113 8.91339 4.16113C6.91998 4.16113 5.30304 5.38231 5.30304 6.87857C5.30304 8.37466 6.9248 9.59584 8.91339 9.59584ZM8.91339 5.12634C10.3613 5.12634 11.5584 5.92766 11.5584 6.8784C11.5584 7.82932 10.3468 8.63047 8.91339 8.63047C7.47979 8.63047 6.26825 7.82932 6.26825 6.8784C6.26825 5.92766 7.47979 5.12152 8.91339 5.12152V5.12634Z" fill="#019CDE"/>
        <path d="M24.2186 11.8982H17.0945V6.87349C17.0945 3.57214 13.4215 0.883789 8.88931 0.883789C4.35697 0.883789 0.68396 3.57214 0.68396 6.87349V12.8103C0.68396 15.8511 3.79716 18.3609 7.80808 18.7422H7.89019C8.22312 18.7713 8.56103 18.7954 8.90377 18.7954H24.2186C24.4851 18.7954 24.7013 18.5792 24.7013 18.3127V12.3807C24.7013 12.1144 24.4851 11.8982 24.2186 11.8982ZM8.91341 1.85381C12.8952 1.85381 16.1534 4.10785 16.1534 6.87848C16.1534 9.64894 12.9147 11.903 8.91341 11.903C4.91213 11.903 1.67344 9.64894 1.67344 6.87831C1.67344 4.10785 4.93623 1.85381 8.91341 1.85381ZM16.1534 9.69232V11.8982H13.3538C14.4466 11.4029 15.3999 10.6451 16.1291 9.69232H16.1534ZM23.7359 17.83H22.7705V15.3877C22.7705 15.1213 22.5543 14.905 22.288 14.905C22.0216 14.905 21.8053 15.1212 21.8053 15.3877V17.8348H19.8746V16.5074C19.8746 16.241 19.6584 16.0248 19.3919 16.0248C19.1254 16.0248 18.9092 16.241 18.9092 16.5074V17.8348H16.9786V16.5074C16.9786 16.241 16.7624 16.0248 16.4959 16.0248C16.2295 16.0248 16.0133 16.241 16.0133 16.5074V17.8348H14.0825V15.3877C14.0825 15.1213 13.8663 14.905 13.5998 14.905C13.3335 14.905 13.1171 15.1212 13.1171 15.3877V17.8348H11.2687V16.5074C11.2687 16.241 11.0523 16.0248 10.786 16.0248C10.5195 16.0248 10.3033 16.241 10.3033 16.5074V17.8348H8.91306C8.72973 17.8348 8.55122 17.8348 8.37254 17.8348V16.5074C8.37254 16.241 8.15633 16.0248 7.88985 16.0248C7.62337 16.0248 7.40716 16.241 7.40716 16.5074V17.719C4.14953 17.2363 1.69754 15.2188 1.69754 12.8055V9.69232C3.07795 11.5795 5.79539 12.8634 8.93751 12.8634H23.7359V17.83Z" fill="#019CDE"/>
      </svg>
      <a href="#size-modal" class="btn-size-modal" rel="modal:open">
        סרגל מידות
      </a>
    </div>
    <a v-if="showStocks" href="#stock-modal" :class="linkClass" rel="modal:open" style="margin-top: 16px; ">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 0.900037C7.59873 0.897978 6.22096 1.26 5.0017 1.95064C3.78244 2.64127 2.76352 3.63682 2.04479 4.83972C1.32606 6.04263 0.93217 7.41163 0.901722 8.81257C0.871273 10.2135 1.20531 11.5983 1.8711 12.8313L0.937799 15.9408C0.897368 16.0753 0.888947 16.2173 0.913207 16.3556C0.937468 16.4938 0.993737 16.6245 1.07752 16.7372C1.1613 16.8498 1.27027 16.9413 1.39572 17.0043C1.52117 17.0673 1.65962 17.1001 1.8 17.1C1.88776 17.0999 1.97505 17.0872 2.0592 17.0622L5.1687 16.1289C6.25402 16.7144 7.45869 17.0443 8.69087 17.0936C9.92304 17.1428 11.1502 16.9101 12.2788 16.4131C13.4074 15.9161 14.4076 15.168 15.2031 14.2258C15.9987 13.2836 16.5687 12.1721 16.8695 10.9762C17.1704 9.78035 17.1942 8.53155 16.9392 7.32504C16.6842 6.11853 16.1571 4.98618 15.3981 4.0143C14.639 3.04242 13.6681 2.25668 12.5593 1.71698C11.4505 1.17727 10.2332 0.897861 9 0.900037ZM9 4.50004C9.178 4.50004 9.35201 4.55282 9.50001 4.65171C9.64802 4.75061 9.76337 4.89117 9.83149 5.05562C9.89961 5.22008 9.91743 5.40104 9.88271 5.57562C9.84798 5.7502 9.76226 5.91057 9.63639 6.03643C9.51053 6.1623 9.35016 6.24802 9.17558 6.28274C9.001 6.31747 8.82004 6.29965 8.65558 6.23153C8.49113 6.16341 8.35057 6.04805 8.25168 5.90005C8.15278 5.75205 8.1 5.57804 8.1 5.40004C8.1 5.16134 8.19482 4.93242 8.3636 4.76364C8.53239 4.59486 8.7613 4.50004 9 4.50004ZM9.9 13.5H9C8.7613 13.5 8.53239 13.4052 8.3636 13.2364C8.19482 13.0677 8.1 12.8387 8.1 12.6V9.00004C7.8613 9.00004 7.63239 8.90522 7.4636 8.73643C7.29482 8.56765 7.2 8.33873 7.2 8.10004C7.2 7.86134 7.29482 7.63242 7.4636 7.46364C7.63239 7.29486 7.8613 7.20004 8.1 7.20004H9C9.23869 7.20004 9.46761 7.29486 9.63639 7.46364C9.80518 7.63242 9.9 7.86134 9.9 8.10004V11.7C10.1387 11.7 10.3676 11.7949 10.5364 11.9636C10.7052 12.1324 10.8 12.3613 10.8 12.6C10.8 12.8387 10.7052 13.0677 10.5364 13.2364C10.3676 13.4052 10.1387 13.5 9.9 13.5Z" fill="#000000" :style="`fill: ${fillColor(window?.produc?.selected_ean)};`"></path>
      </svg>
    </a>
    <div v-for="(option, idx) in options" :key="option.id" class="product__option" :data-id="option.id"
         :class="option.class" :id="option.id">
      <div class="product__option__title">
        {{ option.name }}:
        <div class="tooltip" v-if="option.id === 24">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.68219" width="18" height="18" rx="9" fill="white"/>
            <path d="M9.49962 0.68219C4.52971 0.68219 0.5 4.7119 0.5 9.68181C0.5 14.6517 4.52971 18.6822 9.49962 18.6822C14.4695 18.6822 18.5 14.6517 18.5 9.68181C18.5 4.7119 14.4695 0.68219 9.49962 0.68219ZM11.3731 14.6304C10.9099 14.8132 10.5411 14.9519 10.2646 15.0479C9.98876 15.1439 9.668 15.1919 9.30305 15.1919C8.74229 15.1919 8.30571 15.0548 7.99486 14.7812C7.684 14.5077 7.52933 14.161 7.52933 13.7397C7.52933 13.5759 7.54076 13.4083 7.56362 13.2376C7.58724 13.067 7.62457 12.875 7.67562 12.6593L8.25543 10.6113C8.30648 10.4148 8.35067 10.2281 8.38571 10.0544C8.42076 9.87914 8.43752 9.71838 8.43752 9.57209C8.43752 9.31152 8.38343 9.12867 8.276 9.02581C8.16705 8.92295 7.9621 8.87267 7.65657 8.87267C7.50724 8.87267 7.35333 8.89476 7.19562 8.94124C7.03943 8.98924 6.90381 9.03267 6.79257 9.07533L6.94571 8.44448C7.32514 8.28981 7.68857 8.15724 8.03524 8.04752C8.38191 7.93629 8.70952 7.88143 9.0181 7.88143C9.57505 7.88143 10.0048 8.01705 10.3072 8.28524C10.6082 8.55419 10.7598 8.9039 10.7598 9.33362C10.7598 9.42276 10.7491 9.57971 10.7286 9.80371C10.708 10.0285 10.6691 10.2334 10.6128 10.4216L10.036 12.4635C9.98876 12.6273 9.94686 12.8148 9.90876 13.0243C9.87143 13.2338 9.85314 13.3938 9.85314 13.5012C9.85314 13.7725 9.91333 13.9576 10.0352 14.0559C10.1556 14.1542 10.3667 14.2037 10.6653 14.2037C10.8063 14.2037 10.964 14.1786 11.1423 14.1298C11.319 14.081 11.447 14.0376 11.5278 14.0003L11.3731 14.6304ZM11.271 6.34238C11.0021 6.59229 10.6783 6.71724 10.2996 6.71724C9.92171 6.71724 9.59562 6.59229 9.32438 6.34238C9.05467 6.09248 8.91829 5.78848 8.91829 5.43343C8.91829 5.07914 9.05543 4.77438 9.32438 4.52219C9.59562 4.26924 9.92171 4.14352 10.2996 4.14352C10.6783 4.14352 11.0029 4.26924 11.271 4.52219C11.54 4.77438 11.6749 5.07914 11.6749 5.43343C11.6749 5.78924 11.54 6.09248 11.271 6.34238Z" fill="#C5C5C5"/>
          </svg>
          <span class="tooltip-text">עובי ידית</span>
        </div>
      </div>
      <div class="product__option__values">
        <template v-if="option.value_type === 1">
          <option-slider :option="option" :is-disabled="isDisabled" :selected="selected"
                         @click="(e) => { onValueClick(e.option, e.val) }"/>
        </template>
        <template v-else-if="option.value_type === 2">
          <option-select :option="option" :is-disabled="isDisabled" :selected="selected"
                         @onChange="(e) => { onValueClick(e.option, e.val) }"/>
        </template>
        <template v-else-if="option.value_type === 3">
          <option-color :option="option" :selected="selected" @click="(e) => { onValueClick(e.option, e.val) }"/>
        </template>
      </div>
    </div>
    <div v-if="showRadio && product.stretching_from > 0 && product.stretching_to > 0" class="option">
      <div class="size-modal-row">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.7337 21.5679H5.73809C5.25258 21.5679 4.76923 21.1802 4.76923 20.599C4.76923 20.0568 5.20478 19.6213 5.73809 19.6213H20.7337C21.2352 19.6213 21.6226 19.2016 21.6226 18.7324C21.6226 18.6241 21.6138 4.32508 21.6137 4.21682C21.6137 2.99904 20.627 2.01239 19.4092 2.01239C15.7916 2.01239 9.12181 2.01239 5.73809 2.01239C4.26683 2.01239 2.99146 3.2166 2.99146 4.75908V20.599C2.99146 22.1627 4.26665 23.3457 5.73809 23.3457H20.7337C21.2226 23.3457 21.6226 22.9457 21.6226 22.4568C21.6226 21.968 21.2226 21.5679 20.7337 21.5679ZM4.76923 4.75908C4.76923 4.23461 5.21368 3.79017 5.73809 3.79017H6.55591V17.8435C5.99688 17.8784 5.52671 17.7485 4.76923 18.0213V4.75908ZM11.1781 9.18573C11.1781 8.71459 11.4359 8.27905 11.8448 8.05682C12.2537 7.8257 12.7603 7.8435 13.1603 8.10126L15.7026 9.73684C16.0759 9.96796 16.2981 10.3768 16.2981 10.8213C16.2981 11.2569 16.0759 11.6657 15.7026 11.8968L13.1603 13.5324C12.7844 13.783 12.2724 13.8101 11.8448 13.5768C11.4359 13.3546 11.1781 12.9191 11.1781 12.4479V9.18573Z" fill="#019CDE"/>
        </svg>
        <a href="#strings-modal" rel="modal:open" class="btn-size-modal">הסבר שירותי שיזור</a>
      </div>
      <div class="product__option range-option" >
        <div class="product__option__title">מתיחה:</div>
        <div  class="product__option__values">
<!--          <div class="range-container" id="range-container">
            <input dir="ltr" type="range" id="range" min="50" max="59" v-model="rangeValue" class="range">
            <label for="range" :style="{left: `${labelOffset}`}">{{rangeValue}}</label>
          </div>-->
<!--          <slider v-model="rangeValue" :min="50" :max="59"></slider>-->
          <slider v-model="rangeValue" :min="product.stretching_from" :max="product.stretching_to"></slider>
        </div>
      </div>
      <div id="strings-modal" class="modal" style="text-align: right;">
        <div class="pre-order-modal__body">
          <div class="strings-page">
            <div class="strings-page__caption">שירותי שיזור</div>
            <div class="strings-page__info">
              <div class="strings-page__info-text">
                עלות שיזור (העבודה בלבד) 60 ש"ח + עלות הגידים לפי בחירה שלכם
                <div class="strings-page__separator"></div>
                בקניית מחבט טניס בחנות המקוונת שלנו או בחנות פיזית, ניתן להזמין שירות שיזור גידים.
                <br><br>
                <div class="bold">את שיזור הגידים אנו שוזרים ע"י שוזרים מקצועיים ועל מכונות Babolat.</div>
                <br>
                בבחירת הגידים בהזמנה, תוכלו להשאיר את הערכים האישיים שלכם למתיחה של הגידים במחבט הטניס, או שנוכל לבצע מתיחה בהתאם לערך המומלץ על ידי היצרן עבור המחבט שלך.
                <br>
                <br>
                <div class="bold">שימו לב כי בהזמנת מחבט עם שירות שיזור, זמן עיבוד ההזמנה עשוי לעלות ב: 1-2 ימים</div>
              </div>
              <div class="strings-page__info-img">
                <img src="/client/img/process-of-stringing-a-tennis-racket-in-a-tennis-shop-sport-and-leisure-concept 1.png" alt="">
              </div>
            </div>
            <div class="strings-page__separator"></div>
            <div class="strings-page__video">
              <div class="strings-page__caption">סרטון הסבר</div>
              <div class="video">
                <iframe
                  width="100%" height="100%"
                  src="https://www.youtube.com/embed/zY0kbU0RhmQ"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  frameborder="0">
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="stock-modal" class="modal">
      <div class="stock-modal__header">{{selectedEan}}</div>
      <div class="stock-modal__body">
        <div class="stock-table">
          <div class="stock-table__header">Babolat</div>
          <div class="stock-table__body">
            <div class="stock-table__body-row">
              <div class="stock-table__body-col">מחסן</div>
              <div class="stock-table__body-col">מלאי</div>
              <div class="stock-table__body-col">מוזמן</div>
              <div class="stock-table__body-col">יתרה</div>
            </div>
            <div v-for="(qty, wh) in activeStocks" class="stock-table__body-row">
              <div class="stock-table__body-col">{{wh}}</div>
              <div class="stock-table__body-col">{{qty['quantity']}}</div>
              <div class="stock-table__body-col">{{qty['reserved'] ?? 0}}</div>
              <div class="stock-table__body-col">{{qty['left']}}</div>
            </div>
          </div>
        </div>
        <div class="stock-table">
          <div class="stock-table__header">מלאי בדרך</div>
          <div class="stock-table__body">
            <div class="stock-table__body-row">
              <div class="stock-table__body-col-lg">תאריך הגעה משוער</div>
              <div class="stock-table__body-col">כמות</div>
            </div>
            <div v-for="item in activeOnWay" class="stock-table__body-row">
              <div class="stock-table__body-col-lg">{{item['due_date']}}</div>
              <div class="stock-table__body-col">{{item['quantity']}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, nextTick, onMounted, ref, toRef} from "vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.scss';
import SwiperCore, {
  Navigation,
  Virtual
} from 'swiper/core';
import tippy from "tippy.js";
import OptionColor from "./options/color-option";
import OptionSlider from "./options/slider-option";
import OptionSelect from "./options/select-option";
import Slider from "@vueform/slider";
import "@vueform/slider/themes/default.css";
import axios from "axios"
// install Swiper modules
SwiperCore.use([Navigation, Virtual]);

export default {
  name: "ProductOptions",
  props: {
    color_id: {},
    productOptions: {},
    showSizeModal: false,
  },
  components: {
    OptionSelect,
    OptionSlider,
    OptionColor,
    Swiper,
    SwiperSlide,
    Slider
  },
  setup(props, {emit}) {
    const color_id = computed(() => props.color_id ? props.color_id : window.product?.color_id)
    const options = computed(() => props.productOptions ? props.productOptions.options : window.productOptions?.options || [])
    const variants = computed(() => props.productOptions ? props.productOptions.variants : window.productOptions?.variants || {})
    const combinations = computed(() => props.productOptions ? props.productOptions.combinations : window.productOptions?.combinations || {})
    const showSizeModal = computed(() => props.productOptions ? props.productOptions.showSizeModal : window.showSizeModal || false)

    const product = ref(window.product)

    const labelOffset = computed(() => {
      let range = document.getElementById("range-container");
      let length = document.querySelector('.prod-modal__wrapper') ? 28.2 : (window.innerWidth >= 480 ? 30.75 : (window.innerWidth * 0.067));
      if(range) {
        length = document.querySelector('.prod-modal__wrapper') ? range.offsetWidth / 10 - 0.2 : range.offsetWidth / 10 - 0.25;
      }
      let offset = 0;
      offset = length * (rangeValue.value - 50) + 7.5 + 'px'
      /*if(rangeValue.value >= 58) {
        offset = length === 31 ? ((rangeValue.value -  50) * length + 4.5) + 'px' : ((rangeValue.value - 50) * length) + 'px';
      } else if (rangeValue.value > 55 && rangeValue.value < 58) {
        offset = length === 31 ? ((rangeValue.value -  50) * length + 6) + 'px' : ((rangeValue.value - 50) * length + 2) + 'px';
      } else if(rangeValue.value < 54 && rangeValue.value >= 52) {
        offset = length === 31 ? ((rangeValue.value -  50) * length + 8) + 'px' : ((rangeValue.value -  50) * length + 6) + 'px';
      } else if(rangeValue.value < 52) {
        offset = length === 31 ? ((rangeValue.value -  50) * length + 8) + 'px' : ((rangeValue.value -  50) * length + 8) + 'px';
      } else {
        offset = length === 31 ? ((rangeValue.value -  50) * length + 6) + 'px' : ((rangeValue.value -  50) * length + 4) + 'px';
      }*/
      return offset
    })

    const valOpts = computed(() => {
      return options.value.flatMap(o => o.values.map(v => {
        return {
          val_id: v.id,
          opt: o,
        }
      })).reduce((a, i) => {a[i.val_id] = i.opt; return a}, {})
    })

    onMounted(async () => {
      nextTick(() => {
        tippy('[data-tippy-content]', {
          theme: 'light',
        });
      })
      const opt = options.value.find(el => el.id === 'o9')
      window.product.selected = Object.values(options.value).reduce((a, i) => {

        if (i.value_type === 3) {
          a[i.id] = color_id.value
        } else if (i.id === 'o9') {
          a[i.id] = null;
        } else {
          a[i.id] = null;
        }
        return a
      }, {});
      if (opt) {
        onValueClick(opt, opt.values[0])
      }
      showStocks.value = window?.isAdmin
    })

    const showRadio = ref(false);
    // const rangeValue = ref(55);
    const rangeValue = ref(product.value.stretching_from + Math.floor((product.value.stretching_to - product.value.stretching_from) / 2))
    const linkClass = ref('btn-size-modal btn-disabled')
    const activeStocks = ref({})
    const activeOnWay = ref([])
    const selectedEan = ref(null);
    const showStocks = ref(false);

    const selected = ref(Object.values(options.value).reduce((a, i) => {

      if (i.value_type === 3) {
        a[i.id] = color_id.value
      } else if( i.id === 'o9') {
        a[i.id] = null;
      }else  {
        a[i.id] = null;
      }
      return a
    }, {}))

    const onValueClick = (option, val) => {
      const variant = findVariant(val.id)
      if (option.value_type === 3) {
        selectColor(val.id)
        if(variant){
          const el = document.getElementById('product-article')
          if(el){
            el.innerText = variant.article
          }
        }
      }

      const pr1 = document.querySelector('.prod__price__current')
      const pr2 = document.querySelector('.product-info__price-current')
      if(pr1){
        pr1.innerText = `₪${variant?.price}`
      }

      if(pr2){
        pr2.innerText = `₪${variant?.price}`
      }

      const pr11 = document.querySelector('.product-info__price-old')
      const pr22 = document.querySelector('.prod__price__old')
      console.log('variant', variant);
      window.product.selected_ean = variant?.ean
      selectedEan.value = variant?.ean;
      showStocks.value = window?.isAdmin;
       activeStocks.value = window?.stocks?.[+variant?.ean] ?? {}

       if(activeStocks.value && Object.keys(activeStocks.value).length) {
         activeOnWay.value = (window?.onWay || []).filter(i => i.model === Object.values(activeStocks.value)[0]?.model)
       }
      if(typeof variant !== 'undefined') {
        if(("old_price" in variant) && variant?.old_price !== variant?.price){
          if(pr11){
            pr11.innerText = `₪${variant?.old_price}`
          }

          if(pr22){
            pr22.innerText = `₪${variant?.old_price}`
          }
        } else{
          if(pr11) {
            pr11.innerText = ``
          }
          if(pr22){
            pr22.innerText = ``
          }
        }
      }
      if(option.id === "o9") {
        showRadio.value = val.id !== "ov25" && val.id !== "ov32" && !!val.id;
      }
      console.log(showRadio.value)

      selected.value[option.id] = val.id
      if (isDisabled(option.id, val.id)) {
        findAndSelect(val.id)
      }
      selectVariant()
      if(selected.value) {
        window.product.selected = selected.value;
        if(!Object.values({...selected.value}).filter(i => !i).length) {
          linkClass.value = activeStocks.value ? 'btn-size-modal' : 'btn-size-modal btn-disabled'
        }
      }
    }

    const selectColor = (id) => {
      window.dispatchEvent(new CustomEvent('colorSelected', {
        detail: {
          color_id: id
        }
      }))
    }

    const findVariant = (valId) => {
      const tKeys = {}
      const tVals = Object.values({...selected.value}).filter(i => !!i);

      for (const kv in variants.value) {
        const vi = variants.value[kv]
        if(valId){
          if (!vi.attr_values.includes(valId)) continue
        }

        tKeys[kv] = vi.attr_values.filter(i => tVals.includes(i)).length
      }
      const max = Math.max(...Object.values(tKeys));
      const t = Object.entries(tKeys).filter((v) => {
        return v[1] === max
      }).map((v) => v[0]).sort((a, b) => a.toString().length - b.toString().length)
      if (t.length) {
        return variants.value[t[0]]
      }
    }
    const findAndSelect = (valId) => {
     const variant = findVariant(valId)
      if(variant){
        const attrs = variant.attr_values
        clearSelected()
        for (const av of attrs){
          const o = valOpts.value[av]
          selected.value[o.id] = av
          if(o.value_type === 3){
            selectColor(av)
          }
        }

        selectVariant()
      }
    }

    const clearSelected = () => {
      for (const o of options.value){
        selected.value[o.id] = null
      }
    }

    const selectedKey = computed(() => {
      return Object.values(selected.value).filter(i => !!i).map(i => i.toString()).sort().join('-')
    })

    const selectedVariant = computed(() => {
      return variants.value[selectedKey.value]
    })

    const isDisabled = (optId, valId) => {
      const tv = {...selected.value,}
      tv[optId] = null
      const fv = Object.values(tv).filter(i => !!i);
      if (!fv.length) {
        if(options.value.length == 1) {
          return !combinations.value[valId]?.includes(valId)
        }
        return false
      }
      const tk = fv.sort().join('-')
      //console.log(optId, valId, tk, fv, combinations.value[tk])
      return !combinations.value[tk]?.includes(valId)
    }

    const selectVariant = () => {
      nextTick(() => {
        if (selectedVariant.value) {
          const options = Object.values(selected.value).map(i => {
            if(i && valOpts.value[i].option_type === 'opt'){
              return {
                opt_id: valOpts.value[i].id.toString().replace(/\D/g,''),
                val_id: i.toString().replace(/\D/g,''),
              }
            }
          }).filter(i => i)
          const variant = {...selectedVariant.value}

          const data = {
            variant: variant,
            options: options
          };

          emit('selected', data)
          window.dispatchEvent(new CustomEvent('variantSelected', {
            detail: data
          }))
        }
      })
      let total = 0; console.log(selected.value);
      Object.values(selected.value).forEach((item) => {
        let option = valOpts.value[item]?.values.find(i =>i.id === item);
        if(option && "price" in option) {
          total += option.price;

        }
      })
      if(document.getElementById('price')) {
        document.getElementById('price').innerHTML = '₪' + (window.product.price + total)
        window.product.total_price = window.product.price + total;
      }
    }

    const getStocks = async () => {
      return await axios.get(`/getStocks/${window.product.id}`);
    }

    const fillColor = (ean) => {
      const available = Object.values((activeStocks.value) ?? {}).find(i => i.left > 0)
      const onWay = activeOnWay.value.length;
      if(linkClass.value.includes('disabled')) return '#000000'
      if(available) {
        return '#75a74d';
      }
      if(!available && onWay) {
        return '#c87b1d'
      } else {
        return '#000000';
      }
    }

    //findAndSelect();
    selectVariant();

    return {
      selectedKey,
      selectedVariant,
      options,
      selected,
      onValueClick,
      isDisabled,
      showSizeModal,
      showRadio,
      rangeValue,
      labelOffset,
      getStocks,
      linkClass,
      activeStocks,
      fillColor,
      selectedEan,
      activeOnWay,
      product,
      showStocks
    }
  }
}
</script>

<style lang="scss">
@import '../../../client/scss/_mixins.scss';

.product {
  &__options {

    border-top: 1px solid #E3E3E3;
    border-bottom: 1px solid #E3E3E3;
  }
  .tooltip {
    position: relative;
    display: inline-block;
    &:hover {
      .tooltip-text {
        visibility: visible;
      }
    }
    &-text {
      visibility: hidden;
      width: 120px;
      background-color: black;
      color: #fff;
      text-align: center;
      padding: 5px 0;
      border-radius: 6px;
      position: absolute;
      z-index: 1;
      bottom: 100%;
      left: 50%;
      margin-left: -60px;
      &:after {
        content: " ";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: black transparent transparent transparent;
      }
    }
  }
  .range-option {
    margin-bottom: 30px;
  }
  .option {
    @include bp(phone) {
      max-width: cvp(290px);
    }
    @include bp(sm) {
      max-width: cvp(290px);
    }
  }

  .order-modal {
    position: absolute;
    z-index: 3;
    height: 16px;
    width: 16px;
    border-radius: 50px;
    background-color: $c-blue;
    padding: 0 3px;
    left: -8px;
    cursor: pointer;
  }

  &__option {
    display: flex;
    align-items: center;
    margin-top: cvw(8px);
    height: fit-content;
    //border-bottom: 1px solid #E3E3E3;
    padding-bottom: 20px;
    $opt: &;

    .select-selected {
      min-height: 60px;
    }
    @include bp(mini) {
      margin-top: cvm(5px);
    }

    @include bp(phone) {
      margin-top: cvp(5px);
      flex-direction: column;
      align-items: start;
      gap: cvp(10px);
      width: 100%;
    }

    @include bp(sm) {
      width: 300px;
    }

    &__title {
      display: flex;
      //align-items: center;
      min-width: cvw(115px);
      font-size: 18px;
      margin-left: 15px;

      @include bp(mini) {
        min-width: cvm(100px);
      }
      @include bp(phone) {
        min-width: cvp(100px);
        font-size: cvp(16px);
        line-height: cvp(18.4px);
      }
      @include bp(sm) {
        font-size: 16px;
        line-height: 18.4px;
      }
    }

    &__navs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: cvw(40px);
      min-width: 28px;
      margin-top: 10px;
      margin-right: 15px;
    }

    &__values {
      display: flex;
      align-items: center;
      max-width: calc(100% - #{cvw(100px)});
      width: 100%;

      @include bp(mini) {
        max-width: calc(100% - #{cvm(100px)});
      }
      @include bp(phone) {
        width: 100%;
        max-width: unset;
      }
      @include bp(sm) {
        width: 300px;
      }
      .swiper-container {
        @include bp(sm) {
          width: 300px;
        }
        .swiper-wrapper {
          @include bp(sm) {
            width: 300px!important;
          }
        }
      }
    }

    &__value {
      cursor: pointer;
      direction: rtl;

      &.disabled {
        //color: #C5C5C5;
        pointer-events: none;
        cursor: default;
        span {
          text-decoration: line-through;
        }
      }
    }

    &.color {
      #{$opt}__value {
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px transparent;
        width: 40px;
        height: 40px;
        border-radius: 50%;

        &.active {
          border-color: #e3e3e3;
        }

        img {
          width: 30px;
          height: 30px;
          border: 1px solid #c5c5c5;
          border-radius: 50%;
        }
      }
    }

    &.slider {
      #{$opt}__value {
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px #C5C5C5;
        border-radius: 3px;
        padding: cvw(7px) cvw(12px);
        position: relative;
        margin-top: 8px;
        &:not(.disabled) {
          &:hover {
            border-color: black;
            background-color: black;
            color: white;
          }
        }


        @include bp(mini) {
          padding: cvm(7px) cvm(15px);
        }

        @include bp(phone) {
          padding: cvp(7px) cvp(15px);
        }

        &.active {
          border-color: #000000;
          background-color: #000000;
          color: #fff;
        }

        img {
          width: 30px;
          height: 30px;
        }
      }
    }

  }
}
.size-modal-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
  @include bp(phone) {
    margin-bottom: 20px;
  }
}
.slider-target {
  /*max-width: 310px;
  width: 300px;*/
  width: 95%;
  background-color: #C5C5C5;
  border-radius: 5px;
  height: 6px;
  --slider-handle-width: 33px;
  --slider-handle-height: 33px;
  --slider-connect-bg: #c5c5c5;
  @include bp(phone) {
    height: 10px;
    background-color: #e3eef3;
    width: 95%;
    max-width: 95%;
    padding: 0 3px;
  }
}
.slider-connect {
  @include bp(phone) {
    background-color: #e3eef3;
  }
}
.slider-handle {
  left: unset !important;
  background-color: #000000;
  &:focus {
    box-shadow: 0 0 0 3px rgba(255,255,255,.188),.5px .5px 2px 1px rgba(0,0,0,.32);
  }
  @include bp(phone) {
    background-color: #019cde;
  }
}
.slider-base {
  @include bp(phone) {
    height: 3px;
    background-color: #019cde;
    border-radius: 5px;
    margin-top: 3px;
  }
}
.slider-tooltip-top {
  bottom: calc(var(--slider-handle-height)/8) !important;
  background: none;
  border: none;
  font-size: 16px;
  font-family: "Arimo", sans-serif;
  font-weight: 400;
  &::before {
    display: none;
  }
  @include bp(phone) {
    bottom: calc(var(--slider-handle-height)/8) !important;
  }
}
</style>

<style lang="scss">

.product__options {
  /*.swiper-container {
    margin: 0;
    //width: 100%;
    max-width: calc(#{cvw((40px + 15px) * 10)} - #{cvw(15px)});
  }*/

  .swiper-container-free-mode > .swiper-wrapper {
    margin: 0;
  }

  .swiper-wrapper {
    max-width: calc(100% - 40px);
    //width: 100%;
  }

  .swiper-slide {
    width: fit-content !important;
  }

  .option-tooltip {
    position: absolute;
    padding: 5px;
    border: 1px solid #E3E3E3;
    border-radius: 5px;
    box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.15);
  }

  .product__option {
    &:first-of-type {
      margin-top: 15px;
    }
  }
  .btn-size-modal {
    text-decoration: underline;
    display: block;
    color: #019CDE;
    margin-right: 10px;
    line-height: 19px;
    &.btn-disabled {
      color: #888888;
      pointer-events: none;
      cursor: unset;
    }
  }
  .size-modal-row {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .range-container {
    height: 6px;
    width: 310px;
    position: relative;
    label {
      position: absolute;
      bottom: 0;
      color: #ffffff;
      top: 3px;
      pointer-events: none;
    }
   .range {
     max-width: 310px;
     -webkit-appearance: none;
     appearance: none;
     width: 100%;
     height: 6px;
     border-radius: 5px;
     background: #c5c5c5;
     outline: none;
     -webkit-transition: .2s;
     transition: opacity .2s;
     margin-bottom: 0;
     padding: 0;
     &:hover {
       opacity: 1;
     }
     &::-webkit-slider-thumb {
       -webkit-appearance: none;
       appearance: none;
       width: 33px;
       height: 33px;
       border-radius: 50%;
       background: #000000;
       cursor: pointer;
     }
     &::-moz-range-thumb {
       width: 33px;
       height: 33px;
       background: #000000;
       cursor: pointer;
     }
   }
  }
}
</style>
